module.exports = __webpack_public_path__ + "static/Sonyax4e-a3c5e75f502a2ad46ddec3db5ec89353.png";